export default __webpack_public_path__ + "static/building-img-da58dba813e2f128d51d4b72044768b7.png";